import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { Role } from '../common/enums/role.enum';

export const authenticatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    const role = authService.getUser()?.role;

    if (
      role === Role.ADMIN ||
      role === Role.SUPERVISOR ||
      role == Role.SUPER_ADMIN
    ) {
      router.navigate(['home/admin']);
      return false;
    }

    return true;
  }
  return true;
};
